import React from "react";
import PropTypes from "prop-types";
import { withClasses } from "@xo-union/react-css-modules";
import classesPropType from "@xo-union/classes-prop-type";
import styles from "../../styles.css";
var List = function List(_ref) {
  var children = _ref.children,
    classes = _ref.classes;
  return /*#__PURE__*/React.createElement("ul", {
    className: classes.list,
    role: "listbox"
  }, children);
};
process.env.NODE_ENV !== "production" ? List.propTypes = {
  children: PropTypes.node,
  classes: classesPropType(['list'])
} : void 0;
export default withClasses(styles)(List);